import { render } from "./Avatar.vue?vue&type=template&id=1dac1046&lang=pug"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/user/Avatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dac1046"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dac1046', __exports__)) {
    api.reload('1dac1046', __exports__)
  }
  
  module.hot.accept("./Avatar.vue?vue&type=template&id=1dac1046&lang=pug", () => {
    api.rerender('1dac1046', render)
  })

}


export default __exports__